export default "__VITE_ASSET__BLw1Dyxv__"